// extracted by mini-css-extract-plugin
export default {"title_container":"SubHeader_title_container__02VXT","title":"SubHeader_title__bxCPi"};